// extracted by mini-css-extract-plugin
export default {"footerButton":"footerButton__BNnM0"};
    if(module.hot) {
      // 1790586301179
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  